import React from 'react';
import Table from 'react-bootstrap/Table';

import Const from '../../util/Constants';
import Display from '../../util/Display';

import './ContactPreview.css';

class ContactInformation extends React.Component {

  constructor(props) {
    super(props);
    this.setContactInfo(props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(props.contact && props.contact.id !== this.id ) {
      this.setContactInfo(props);
    }
  }

  setContactInfo = props => {
    var fields = props.model.fields;
    const keys = Object.keys(fields);
    this.fields = []
    for(var i = 0; i < keys.length; i++) {
      if(keys[i] === 'status' || keys[i] === 'phone' || keys[i] === 'email'
        || fields[keys[i]].status === Const.Trash) {
        continue;
      }
      if(fields[keys[i]].visible === Const.True) {
        const field = fields[keys[i]];
        field.key = keys[i];
        this.fields.push(field);
      }
    }
    this.fields = this.fields.sort((field1, field2) => field1.order - field2.order);
    fields = this.fields;
    const count = Math.floor((fields.length + 1) / 2);
    this.fields1 = [];
    for(let i = 0; i < count; i++ ) {
      const value = Display.FieldValue(props.contact, fields[i].key, props.model.fields);
      this.fields1.push(
        <tr key={`d_f_${fields[i].key}`}>
          <th scope="row">{fields[i].label_name}</th>
          <td>{value}</td>
        </tr>
      );
    }

    this.fields2 = [];
    for(let i = count; i < fields.length; i++ ) {
      const value = Display.FieldValue(props.contact, fields[i].key, props.model.fields);
      this.fields2.push(
        <tr key={`d_f_${fields[i].key}`}>
          <th scope="row">{fields[i].label_name}</th>
          <td>{value}</td>
        </tr>
      );
    }
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="formhead"><h2>Contact Information</h2></div>
        </div>
        <div className="col-md-6">
          <Table striped bordered hover> <tbody> {this.fields1} </tbody> </Table>
        </div>
        <div className="col-md-6">
          <Table striped bordered hover> <tbody> {this.fields2} </tbody> </Table>
        </div>
      </div>                     
    );
  }
}

export default ContactInformation;